import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './api/contentApi.ts'
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://3434d57cd993acaf894c92c052ac12f6@o4509078888644608.ingest.de.sentry.io/4509321164554320",
  ignoreErrors: [
    'ResizeObserver loop limit exceeded',
    /Non-Error exception captured/,
  ],
  sendDefaultPii: true,
  integrations: [Sentry.breadcrumbsIntegration({
    console: true,
    dom: true,
    fetch: true,
    history: true
  }),
  Sentry.captureConsoleIntegration({
    levels: ["error"]
  }),
  Sentry.contextLinesIntegration(),
  Sentry.replayIntegration(),
  ],
  replaysSessionSampleRate: 1,
  replaysOnErrorSampleRate: 1.0,
  attachStacktrace: true,
  tracesSampleRate: 1.0,
  tracePropagationTargets: [/^https:/],
});

createRoot(document.getElementById('root')!).render(

  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
)
